import { useEffect, type RefObject } from 'react'
import type { Attachment } from '../../client'
import InFlightMessage from './InFlightMessage'
import { useInFlight } from '../../providers/chat/context'

type Props = {
  scrollRef: RefObject<HTMLDivElement | null>
  stick: RefObject<boolean>
  onPreview: (attachment: Attachment) => void
}

/** The only subscriber to the streaming turn, so its updates re-render this bubble alone. */
export default function StreamingTurn({ scrollRef, stick, onPreview }: Props) {
  const blocks = useInFlight()

  useEffect(() => {
    const element = scrollRef.current
    if (element && stick.current) element.scrollTop = element.scrollHeight
  })

  if (!blocks) return null
  return <InFlightMessage blocks={blocks} onPreview={onPreview} />
}
